"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNavState = void 0;
var react_1 = __importDefault(require("react"));
var NavState_1 = require("../contexts/NavState");
exports.useNavState = function () { return react_1.default.useContext(NavState_1.NavStateContext); };
